// @flow

import { API_ROOT } from '../../constants/api';

require('es6-promise').polyfill();
require('isomorphic-fetch');

export function parseError(error) {
  return error || 'Something went wrong';
}

export const fetcher = async (url, config?) => {
  config = config||{}
  const API_URL = `${API_ROOT}${url}`;
  const token = window.localStorage.getItem('subscriber-token');

  const options = {
    method: config.method || 'GET',
    headers:{
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }
  };

  

  const responseStream = await fetch(API_URL, options);
  const response = await responseStream.json();
  return response;
};

export function request(url, opts?, apihost?) {

  const { returnStatus, ...options } = opts || {};
  const config = {
    method: 'GET',
    ...options
  };
  const errors:any = [];

  if (!url) {
    errors.push('url');
  }

  if (
    !config.payload &&
    config.method !== 'GET' &&
    config.method !== 'DELETE'
  ) {
    errors.push('payload');
  }

  if (errors.length) {
    throw new Error(`Error! You must pass \`${errors.join('`, `')}\``);
  }
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...config.headers,
  };

  const params = {
    headers,
    method: config.method
  };

  

  const API_ENDPOINT = apihost ? `${apihost}/v1` : API_ROOT;
  // console.log('bvr', apihost, url, params, API_ENDPOINT);
  return fetch(`${API_ENDPOINT}${url}`, {
    ...params,
  }).then(async (response) => {
    if (response.status > 299) {
      const error: any = {
        status: response.statusText
      };
      const cType = response.headers.get('content-type');
      if (cType && cType.includes('application/json')) {
        error.response = {
          status: response.status,
          data: await response.json()
        };
        // console.log(error.response.data);
      } else {
        error.response = {
          status: response.status,
          data: await response.text()
        };
      }

      return error;
    }
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      const resp = await response.json();
      return returnStatus
        ? {
            status: response.status,
            data: resp
          }
        : resp;
    }

    return response.text();
  });
}
